import React, { useState } from "react";
import "../../../pages/services/Services.scss";

// icons
import { FiEdit2 } from "react-icons/fi";

// component
import CompnaySettingsContactStep1 from "./CompnaySettingsContact.step1";

const CompnaySettingsContact = () => {
  const [edit, setEdit] = useState(false);

  return (
    <div className="CompnaySettingsGeneralDetails">
      <div className="flex-1 d-flex-start">
        <h2>Contact Details</h2>
      </div>

      <CompnaySettingsContactStep1 />
    </div>
  );
};

export default CompnaySettingsContact;
